import React, { useState } from 'react';
import { Stack } from '@chakra-ui/react';
import ReusableDrawer from "../../../../components/Drawers/ReusableDrawer.js";
import headerImage from '../../../../assets/img/background.png';
import GradientButton from 'components/Buttons/GradientButton.js';
import ReusableInput from 'components/Inputs/ReusableInput.js';

const AddUserDrawer = ({ isOpen, onClose, onAddUser }) => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '7"hgkjsk*£lgsdGHn',
    phoneNumber: '+267',
    userType: 'Admin',
  });

  const [loading, setLoading] = useState(false); 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phoneNumber' && !value.startsWith('+267')) {
      setFormData((prev) => ({ ...prev, [name]: `+267${value.replace('+267', '')}` }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

 const handleSubmit = async () => {
  setLoading(true); 
  const formDataToSubmit = {
    username: formData.username,
    email: formData.email,
    password: formData.password,
    phone_number: formData.phoneNumber,
    user_type: formData.userType,
  };
  try {
    await onAddUser(formDataToSubmit);
  } catch (error) {
    console.error("Error adding user:", error);
    // Optionally, show a notification about the error
  } finally {
    setLoading(false);
  }
};


  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add New User</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Username"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            placeholder="Enter username"
          />
          <ReusableInput
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Enter email"
          />
          <ReusableInput
            label="Phone Number"
            name="phoneNumber"
            value={formData.phoneNumber.replace('+267', '')}
            onChange={handleInputChange}
            placeholder="Enter phone number"
          />
          <ReusableInput
            label="User Type"
            name="userType"
            type="text"
            value={formData.userType}
            isReadOnly
            placeholder="Admin"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize={"15px"} width={"100px"} height={"40px"}>Cancel</GradientButton>
          <GradientButton onClick={handleSubmit} fontSize={"15px"} width={"100px"} height={"40px"} loading={loading}>Save</GradientButton>
        </Stack>
      }
    />
  );
};

export default AddUserDrawer;
